import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getInvoiceOptions } from 'modules/accommodations/features/reservations/api';

export const useQueryInvoiceOptions = ({ id }: { id: string }) => {
  return useQuery(QUERY_KEYS.INVOICES_INVOICE_OPTIONS, () => getInvoiceOptions({ id }), {
    enabled: !!id,
  });
};
